import { compact } from '../../../../helpers/compact';
import { DocumentType } from '../../../../types/document';
import { LaPosteEn4 } from '../../../../types/page/la-poste-en-4';
import { processSlices } from '../../slices';
import laPosteEn4SliceMapper from '../../slices/la-poste-en-4';
import { pageEntity } from './internal';

const processCustomSlices = processSlices(laPosteEn4SliceMapper);

const processLaPosteEn4 = (entity: any): LaPosteEn4 =>
  compact({
    uid: DocumentType.LA_POSTE_EN_4,
    type: DocumentType.LA_POSTE_EN_4,
    body: processCustomSlices(entity.data?.body_slices),
  });

export const LaPosteEn4Entity = pageEntity<LaPosteEn4>(
  DocumentType.LA_POSTE_EN_4,
  {
    processStrategy: processLaPosteEn4,
  }
);
